export class AttributeType {
    id:number;
    typeName: string;
    constructor(id: number, typeName: string) {
        this.id = id;
        this.typeName = typeName;
    }
}
